import { Action } from '@ngrx/store';
import { IOverrideReporting } from '../../../commons';

export enum OverrideReportingActionTypes {
  LoadOverrideReportingState = '[OverrideReporting] Load OverrideReporting State',
  LoadOverrideReportingStateSuccess = '[OverrideReporting] Load OverrideReporting State Success',
  LoadOverrideReportingStateFail = '[OverrideReporting] Load OverrideReporting State Fail',
  OverrideReportingScreenErrorReset = '[OverrideReporting] OverrideReporting Screen Error Reset'

}

export class LoadOverrideReportingState implements Action {
  readonly type = OverrideReportingActionTypes.LoadOverrideReportingState;
}

export class LoadOverrideReportingStateSuccess implements Action {
  readonly type = OverrideReportingActionTypes.LoadOverrideReportingStateSuccess;
  constructor(public payload: IOverrideReporting ) {}
}

export class LoadOverrideReportingStateFail implements Action {
  readonly type = OverrideReportingActionTypes.LoadOverrideReportingStateFail;
  constructor(public payload: any) {}
}

export class OverrideReportingScreenErrorReset implements Action {
  readonly type = OverrideReportingActionTypes.OverrideReportingScreenErrorReset;
}

export type OverrideReportingActions = 
  LoadOverrideReportingState
  | LoadOverrideReportingStateSuccess
  | LoadOverrideReportingStateFail
  | OverrideReportingScreenErrorReset;